/**
 * RECETTE D'EXCELLENCE — localisation des libellés de statut neutres des
 * cartes vitrine (`homepage_projects.status_label`, stockés en français).
 * Parité EN (arbitrage 2a) : les 4 libellés canoniques connus sont adaptés,
 * tout libellé inconnu est rendu tel quel (fail-soft, aucune invention).
 */
const EN_LABELS = {
  'Projet référence': 'Reference project',
  'En développement': 'In development',
  'En exploitation': 'In operation',
  'À venir': 'Upcoming',
  'Livré': 'Delivered',
  'Projet réalisé': 'Completed project',
};

export const localizeStatusLabel = (label, lang) => {
  if (!label) return label;
  if (lang === 'en') return EN_LABELS[label.trim()] || label;
  return label;
};

export default localizeStatusLabel;

